// htmlのタグ指定用
export class HtmlStringConst {

	static readonly BR = '<br>';	// 改行

}

